export default __webpack_public_path__ + "static/media/NotchpassFilterImg.8a762b79.jpg";